/**
 * @file コンポーネント：フル動画ページスレッドポップアップカード スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledBody = styled.p`
    margin-bottom: 16px;
    color: #000000;
    font-size: 12px;
    line-height: 14px;
    white-space: pre-wrap;

    > a {
        cursor: pointer;
    }
`;

export const StyledButtonList = styled.ul`
    display: flex;
    justify-content: flex-end;
`;

export const StyledButtonListButton = styled.button`
    padding: 0;
    border: none;
    background-color: transparent;
    color: #000000;
    font-size: 11px;
    line-height: 16px;
`;

export const StyledButtonListItem = styled.li`
    margin-right: 8px;

    &:last-child {
        margin-right: 0;
    }

    i.is-rated {
        font-weight: bold;
    }
`;

export const StyledHeadline = styled.h3`
    display: flex;
    align-items: baseline;
    margin-bottom: 16px;
    color: #000000;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
`;

export const StyledHeadlineAnchor = styled.a``;

export const StyledHeadlineReplyCount = styled.span`
    margin-left: 4px;
    font-size: 13px;
    line-height: 18px;
`;

export const StyledHeadlineText = styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const StyledNameSpan = styled.span`
    margin-right: 4px;
`;

export const StyledPostTime = styled.time``;

export const StyledReply = styled.div`
    display: inline-block;
    color: #000000;
    font-size: 11px;
    line-height: 16px;
    text-align: center;
`;

export const StyledReplyCount = styled.span`
    margin-left: 4px;
`;

export const StyledReplyIcon = styled.span`
    margin-right: 4px;
`;

export const StyledReplyText = styled.span``;

export const StyledThreadCard = styled.div`
    padding: 16px;
    background-color: #d9d9d9;

    &.is-editing {
        background-color: #acadae;
    }
`;

export const StyledThreadInfo = styled.p`
    margin-bottom: 16px;
    color: #000000;
    font-size: 11px;
    line-height: 16px;
    text-align: right;

    &::before {
        margin-right: 4px;
        content: "Posted by";
    }

    &.is-list {
        margin-bottom: 0;
    }
`;
